import React from "react";
import ReactQuill from "react-quill";
import calendarIcon from "../../Assets/calendarIcon.svg";
import { useDispatch } from "react-redux";
import { updateItemQuestion } from "../../Redux/Reducer/FormSlices";

const DateQuestion = ({
  id,
  question,
  module,
  questionIndex,
  openQuestion,
  setOpenQuestion,
  containerIndex,
}) => {
  const dispatch = useDispatch();
  const handleQuestionChange = (newQuestion) => {
    dispatch(
      updateItemQuestion({ newQuestion, questionIndex, containerIndex })
    );
  };
  return (
    <>
      <div className="singleQuestion_name_Container">
        {questionIndex + 1}.
        <ReactQuill
          modules={module}
          theme="snow"
          className={`custom ${openQuestion === question.id ? "focus" : ""}`}
          onFocus={() => setOpenQuestion(question.id)}
          onBlur={() => setOpenQuestion(null)}
          value={question.question}
          onChange={handleQuestionChange}
        />
      </div>
      <div className="nameAns_container">
        <div
          className="calander"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div
            style={{
              width: "35%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <div>/</div>
            <div>/</div>
          </div>
          <img src={calendarIcon} alt="calendarIcon" className="calanderIcon" />
        </div>
      </div>
    </>
  );
};

export default DateQuestion;
